import React from 'react';
import { Switch } from 'react-router-dom';
import LoginPage from './components/Authorization/login';
import ForgotPasswordPage from './components/Authorization/forgotpassword';
import ResetPasswordPage from './components/Authorization/resetPassword';
import DashboardPage from './components/Dashboard';
// import RoomPurchasePage from './components/RoomPurchase';
// import EcardPage from './components/Ecards';
// import PacksPage from './components/Packs';
import EcardSalesPage from './components/EcardSales';
import AuthRoute from './routes/authRoute';
import UnauthRoute from './routes/unauthRoute';
import ActivationPage from './components/Activation';
import MeetPage from './meet';
import AddressBookPage from './components/Addressbook';
import ScheduleSession from './components/schedule';
import Userprofile from './components/userProfile/userProfile';
import UsersList from './components/Users/index';
import WatchVideos from './components/WatchVideos';
import PlanManagement from './components/PlanManagement/PlanManagement';

const RouteConfig = () =>
{
	return (
		<Switch>
			<UnauthRoute exact path='/'>
				<LoginPage />
			</UnauthRoute>
			<UnauthRoute exact path='/forgot-password'>
				<ForgotPasswordPage />
			</UnauthRoute>
			<UnauthRoute exact path='/reset_password'>
				<ResetPasswordPage />
			</UnauthRoute>
			<AuthRoute exact path='/dashboard'>
				<DashboardPage />
			</AuthRoute>
			<AuthRoute exact path='/activation'>
				<ActivationPage />
			</AuthRoute>
			<AuthRoute exact path='/e-card-sales'>
				<EcardSalesPage />
			</AuthRoute>
			<AuthRoute exact path='/address-book'>
				<AddressBookPage />
			</AuthRoute>
			<AuthRoute exact path='/meet/:id'>
				<MeetPage />
			</AuthRoute>
			<AuthRoute exact path='/session/:sessionId'>
				<MeetPage isSession />
			</AuthRoute>
			<UnauthRoute exact path='/guest-session/:sessionId'>
				<MeetPage isSession isGuest/>
			</UnauthRoute>
			<AuthRoute exact path='/schedule'>
				<ScheduleSession />
			</AuthRoute>
			<UnauthRoute exact path='/guest-join/:id'>
				<MeetPage isGuest/>
			</UnauthRoute>
			<AuthRoute exact path='/user-profile'>
				<Userprofile />
			</AuthRoute>
			<AuthRoute exact path='/watch-videos'>
				<WatchVideos />
			</AuthRoute>
			<AuthRoute exact path='/users'>
				<UsersList />
			</AuthRoute>
			<AuthRoute exact path='/package-management'>
				<PlanManagement />
			</AuthRoute>
		</Switch>
	);
};

export default RouteConfig;
